import { render, staticRenderFns } from "./TopHeader.ChangeSkin.vue?vue&type=template&id=9127e79c&"
import script from "XC/components/topHeader.component.changeSkin?vue&type=script&lang=js&"
export * from "XC/components/topHeader.component.changeSkin?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports